import React, { Component, useEffect, lazy, Suspense } from 'react';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink, connectToWebsocket, disconnectToWebsocket } from '../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../Login/Actions/LoginAction';
import { withRouter } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
import LoginRoute from '../Login/Routes/LoginRoute';
import DashboardRoute from '../../V4/Modules/Dashboard/Routes/DashboardRoute';
import SupplierRoute from '../../V4/Modules/Supplier/Routes/SupplierRoute';
import ProductRoute from '../../V4/Modules/Product/Routes/ProductRoute';
import ProductLabelRoute from '../../V4/Modules/Product/Routes/ProductLabelRoute';
import CategoryRoute from '../../V4/Modules/Category/Routes/CategoryRoute';
import TaxCodeRoute from '../../V4/Modules/TaxCode/Routes/TaxCodeRoute';
import BillingCounterRoute from '../../V4/Modules/BillingCounter/Routes/BillingCounterRoute';
import PaymentMethodRoute from '../../V4/Modules/PaymentMethod/Routes/PaymentMethodRoute';
import StoreRoute from '../../V4/Modules/Store/Routes/StoreRoute';
import HomeRoute from '../Routes/HomeRoute'
import GlobalSettingsRoute from '../Routes/SettingsRoute';
import SettingsRoute from '../../V4/Modules/Settings/Routes/SettingsRoute';
import SubscriptionRoute from '../Routes/SubscriptionRoute'
import UserRoute from '../Routes/UserRoute'
import AddonGroupRoute from '../../V4/Modules/AddonGroup/Routes/AddonGroupRoute';
import OrderRoute from '../../V4/Modules/Order/Routes/OrderRoute';
import BusinessRegisterRoute from '../../V4/Modules/BusinessRegister/Routes/BusinessRegisterRoute';
import WorkInProgress from '../Utility/Components/WorkInProgress';
import NotificationRoute from '../../V4/Modules/Notification/Routes/NotificationRoute';
import PurchaseOrderRoute from '../../V4/Modules/PurchaseOrder/Routes/PurchaseOrderRoute';
import InvoiceRoute from '../../V4/Modules/Invoice/Routes/InvoiceRoute'
import StockTransferRoute from "../../V4/Modules/Stock/Routes/StockTransferRoutes";
import StockReturnRoute from "../../V4/Modules/Stock/Routes/StockReturnRoutes";
import RestaurantTableRoute from "../../V4/Modules/Restaurant/Routes/RestaurantTableRoute";
import RestaurantMenuRoute from "../../V4/Modules/Restaurant/Routes/RestaurantMenuRoute";
import QuotationRoute from '../../V4/Modules/Quotation/Routes/QuotationRoute'
import AccountRoute from "../../V4/Modules/Account/Routes/AccountRoute";
import MonthlyTargetRoute from "../../V4/Modules/Account/Routes/MontlyTargetRoute";
import DiscountRoute from '../../V4/Modules/Discount/Routes/DiscountRoute';
import BookingEventsRoute from '../../V4/Modules/BookingEvents/Routes/BookingEventsRoute';
// import WorkInProgress from '../Utility/Components/WorkInProgress'
import CalendarRoute from '../../V4/Modules/Calendar/Routes/CalendarRoute';
import KitchenDisplayRoute from '../../V4/Modules/KitchenDisplay/Routes/KitchenDisplayRoute';
import TransactionRoute from '../../V4/Modules/Transaction/Routes/TransactionRoute';

import RestaurantRoute from '../../V4/Modules/Restaurant/Routes/RestaurantRoute';
import ReportsRoute from '../../V4/Modules/Reports/Routes/ReportsRoute';

import RequisitionRoute from '../../V4/Modules/Requisition/Routes/RequisitionRoute'
import GrnRoute from '../../V4/Modules/GRN/Routes/GrnRoute'
import AnotherLoginUrl from '../Login/Pages/AnotherLoginUrl'

function GlobalRoute(props) {
    return (
        <Switch>
            {/* login module route */}
            <Route path="/:lng/settings/billing-counters" component={BillingCounterRoute} />
            <Route path="/:lng/settings/payment-methods" component={PaymentMethodRoute} />
            <Route path="/:lng/settings/stores" component={StoreRoute} />
            <Route path="/:lng/tax-codes" component={TaxCodeRoute} />
            <Route path="/:lng/supplier" component={SupplierRoute} />
            <Route path="/:lng/stock/products" component={ProductRoute} />
            <Route path="/:lng/stock/products-label" component={ProductLabelRoute} />
            <Route path="/:lng/stock/addon-groups" component={AddonGroupRoute} />
            <Route path="/:lng/business/monthly-targets" component={MonthlyTargetRoute} />
            <Route path="/:lng/business/accounts" component={AccountRoute} />
            <Route path="/:lng/restaurant/menu" component={RestaurantMenuRoute} />
            <Route path="/:lng/restaurant/tables" component={RestaurantTableRoute} />
            <Route path="/:lng/stock/return" component={StockReturnRoute} />
            <Route path="/:lng/stock/transfer" component={StockTransferRoute} />
            <Route path='/:lng/sales/invoices' component={InvoiceRoute} />
            <Route path="/:lng/sales/orders" component={OrderRoute} />
            <Route path="/:lng/sales/digital-menu-orders" component={OrderRoute} />
            <Route path="/:lng/sales/transactions" component={TransactionRoute} />
            <Route path="/:lng/business/registers" component={BusinessRegisterRoute} />
            <Route path="/:lng/category" component={CategoryRoute} />
            <Route path="/:lng/dashboard" component={DashboardRoute} />
            <Route path="/:lng/discount-codes" component={DiscountRoute} />
            <Route path="/:lng/home" component={HomeRoute} />
            <Route path="/:lng/settings/bank_details" component={GlobalSettingsRoute} />
            <Route path="/:lng/settings/subscription" component={SubscriptionRoute} />
            <Route path="/:lng/settings" component={SettingsRoute} />
            <Route path="/:lng/user" component={UserRoute} />
            <Route path="/:lng/notification" component={NotificationRoute} />
            <Route path='/:lng/sales/purchase-orders' component={PurchaseOrderRoute} />
            <Route path='/:lng/sales/purchase-orders/:unknown' render={() => <WorkInProgress />} />
            <Route path="/:lng/stock/transfer" render={() => <WorkInProgress />} />
            <Route path="/:lng/restaurant/menu" component={RestaurantMenuRoute} />
            {/* <Route path="/:lng/restaurant/table" component={RestaurantTableRoute} /> */}
            <Route path='/:lng/sales/quotations' component={QuotationRoute} />
            {/* ✅ Catch unknown subpaths under modules */}
            <Route path="/:lng/business/:unknown" render={() => <WorkInProgress />} />
            <Route path="/:lng/settings/:unknown" render={() => <WorkInProgress />} />
            {/* <Route path="/:lng/user/:unknown" render={() => <WorkInProgress />} /> */}
            <Route path="/:lng/home/:unknown" render={() => <WorkInProgress />} />

            <Route path='/:lng/booking-events' component={BookingEventsRoute} />
            <Route
              path='/:lng/booking-events/:unknown'
              render={() => <WorkInProgress />}
            />

            

            <Route path='/:lng/calendar' component={CalendarRoute} />
            <Route path='/:lng/calendar/:unknown' render={() => <WorkInProgress />} />

            <Route path="/:lng/restaurant" component={RestaurantRoute} />
            <Route path="/:lng/reports" component={ReportsRoute} />
            {/* <Route
              path='/:lng/restaurant/kitchen-display'
              component={KitchenDisplayRoute}
            /> */}
            <Route
              path='/:lng/restaurant/kitchen-display/:unknown'
              render={() => <WorkInProgress />}
            />
            
            <Route path='/:lng/sales/requisitions' component={RequisitionRoute} />
            <Route path='/:lng/sales/grn' component={GrnRoute} />

            <Route exact path="/:lng/auto_login" component={AnotherLoginUrl} />

            {/* ✅ Catch-all for unknown :lng paths */}
            <Route path="/:lng/:unknown" render={() => <WorkInProgress />} />

            {/* ✅ Root login path */}
            <Route exact path="/" component={LoginRoute} />

            {/* ✅ Global fallback */}
            <Route component={WorkInProgress} />
        </Switch>
    );

}

function Loading() {
    return (
        <>
            <div className="wrapperContainer">
                <LoadingOverlay
                    active={true}
                    className='lodingOverlayDivContainer'
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: 'rgba(255, 255, 255, 0.1)',
                            zIndex: '9999999999999'
                        })
                    }}
                ></LoadingOverlay>
            </div>
        </>
    );
}


const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
    };
}


export default connect(mapStateToProps, { handleActiveLink, setUserCredentials })(withRouter(GlobalRoute));
